/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import { t } from 'i18next';

import test_img from '../../images_speaker/frog.png'
import empty_img1 from '../../images_speaker/empty1.png'
import empty_img2 from '../../images_speaker/empty2.png'


const SymposiumSchedule = () => {
    return(
        <div className="sect-01-box-01-seminar">
            <div className="sect-tit">{t("symposium_schedule_title")}</div>
            <div className="tbl-seminar-schedule">
            <div style={{display:"inline-block", width:"90%", maxWidth:"1300px"}}>
                <p>{t("symposium_schedule_date0")}</p>
                <table>
                    <colgroup>
                        {/* <col width="38%"/> */}
                        <col width="15%"/>
                        <col width="15%"/>
                        <col width="50%"/>
                        <col width="20%"/>
                    </colgroup>
                    <tbody>
                    <tr>
                        <td class="left theme" colSpan="3">{t("symposium_schedule_date0_theme")}</td>
                        <td class="right mc" colSpan="1">{t("symposium_schedule_date0_mc1")}</td>
                    </tr>
                    <tr class="purple borderUpBoldPurple">
                        {/* <th rowSpan="8"></th> */}
                        <td>{t("symposium_schedule_col1")}</td>
                        <td>{t("symposium_schedule_col2")}</td>
                        <td>{t("symposium_schedule_col3")}</td>
                        <td>{t("symposium_schedule_col4")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date0_sem1_hours")}</td>
                        <td>{t("symposium_schedule_date0_sem1_time")}</td>
                        <td>{t("symposium_schedule_date0_sem1_title")}</td>
                        <td>{t("symposium_schedule_date0_sem1_speaker")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date0_sem2_hours")}</td>
                        <td>{t("symposium_schedule_date0_sem2_time")}</td>
                        <td>{t("symposium_schedule_date0_sem2_title")}</td>
                        <td>{t("symposium_schedule_date0_sem2_speaker")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date0_sem3_hours")}</td>
                        <td>{t("symposium_schedule_date0_sem3_time")}</td>
                        <td>{t("symposium_schedule_date0_sem3_title")}</td>
                        <td>{t("symposium_schedule_date0_sem3_speaker")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date0_sem4_hours")}</td>
                        <td>{t("symposium_schedule_date0_sem4_time")}</td>
                        <td>{t("symposium_schedule_date0_sem4_title")}</td>
                        <td>{t("symposium_schedule_date0_sem4_speaker")}</td>
                    </tr>
                    <tr>
                        <td class="left theme" colSpan="3"></td>
                        <td class="right mc" colSpan="1">{t("symposium_schedule_date0_mc2")}</td>
                    </tr>
                    <tr class="purple borderUpBoldPurple">
                        {/* <th rowSpan="8"></th> */}
                        <td>{t("symposium_schedule_col1")}</td>
                        <td>{t("symposium_schedule_col2")}</td>
                        <td>{t("symposium_schedule_col3")}</td>
                        <td>{t("symposium_schedule_col4")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date0_sem5_hours")}</td>
                        <td>{t("symposium_schedule_date0_sem5_time")}</td>
                        <td>{t("symposium_schedule_date0_sem5_title")}</td>
                        <td>{t("symposium_schedule_date0_sem5_speaker")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date0_sem6_hours")}</td>
                        <td>{t("symposium_schedule_date0_sem6_time")}</td>
                        <td>{t("symposium_schedule_date0_sem6_title")}</td>
                        <td>{t("symposium_schedule_date0_sem6_speaker")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date0_sem7_hours")}</td>
                        <td>{t("symposium_schedule_date0_sem7_time")}</td>
                        <td>{t("symposium_schedule_date0_sem7_title")}</td>
                        <td>{t("symposium_schedule_date0_sem7_speaker")}</td>
                    </tr>
                    </tbody>
                </table>
                <p>{t("symposium_schedule_date1")}</p>
                <table>
                    <colgroup>
                        {/* <col width="38%"/> */}
                        <col width="15%"/>
                        <col width="15%"/>
                        <col width="50%"/>
                        <col width="20%"/>
                    </colgroup>
                    <tbody>
                    <tr>
                        <td class="left theme" colSpan="3">{t("symposium_schedule_date1_theme")}</td>
                        <td class="right mc" colSpan="1">{t("symposium_schedule_date1_mc1")}</td>
                    </tr>
                    <tr class="purple borderUpBoldPurple">
                        {/* <th rowSpan="8"></th> */}
                        <td>{t("symposium_schedule_col1")}</td>
                        <td>{t("symposium_schedule_col2")}</td>
                        <td>{t("symposium_schedule_col3")}</td>
                        <td>{t("symposium_schedule_col4")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date1_sem1_hours")}</td>
                        <td>{t("symposium_schedule_date1_sem1_time")}</td>
                        <td>{t("symposium_schedule_date1_sem1_title")}</td>
                        <td>{t("symposium_schedule_date1_sem1_speaker")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date1_sem2_hours")}</td>
                        <td>{t("symposium_schedule_date1_sem2_time")}</td>
                        <td>{t("symposium_schedule_date1_sem2_title")}</td>
                        <td>{t("symposium_schedule_date1_sem2_speaker")}</td>
                    </tr>
                    {/* <tr>
                        <td>{t("symposium_schedule_date1_break_morning_hours")}</td>
                        <td>{t("symposium_schedule_date1_break_morning_time")}</td>
                        <td>{t("symposium_schedule_date1_break_morning_title")}</td>
                        <td>{t("symposium_schedule_date1_break_morning_speaker")}</td>
                    </tr> */}
                    <tr>
                        <td>11:00~11:30</td>
                        <td>{t("symposium_schedule_date1_sem3_time")}</td>
                        <td>{t("symposium_schedule_date1_sem3_title")}</td>
                        <td>{t("symposium_schedule_date1_sem3_speaker")}</td>
                    </tr>
                    <tr>
                        <td>11:30~12:00</td>
                        <td>{t("symposium_schedule_date1_sem4_time")}</td>
                        <td>{t("symposium_schedule_date1_sem4_title")}</td>
                        <td>{t("symposium_schedule_date1_sem4_speaker")}</td>
                    </tr>
                    <tr>
                        <td class="left theme" colSpan="3"></td>
                        <td class="right mc" colSpan="1">{t("symposium_schedule_date1_mc2")}</td>
                    </tr>
                    <tr class="purple borderUpBoldPurple">
                        {/* <th rowSpan="8"></th> */}
                        <td>{t("symposium_schedule_col1")}</td>
                        <td>{t("symposium_schedule_col2")}</td>
                        <td>{t("symposium_schedule_col3")}</td>
                        <td>{t("symposium_schedule_col4")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date1_sem5_hours")}</td>
                        <td>{t("symposium_schedule_date1_sem5_time")}</td>
                        <td>{t("symposium_schedule_date1_sem5_title")}</td>
                        <td>{t("symposium_schedule_date1_sem5_speaker")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date1_sem6_hours")}</td>
                        <td>{t("symposium_schedule_date1_sem6_time")}</td>
                        <td>{t("symposium_schedule_date1_sem6_title")}</td>
                        <td>{t("symposium_schedule_date1_sem6_speaker")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date1_break_hours")}</td>
                        <td>{t("symposium_schedule_date1_break_time")}</td>
                        <td>{t("symposium_schedule_date1_break_title")}</td>
                        <td>{t("symposium_schedule_date1_break_speaker")}</td>
                    </tr>
                    <tr>
                        <td>{t("symposium_schedule_date1_sem7_hours")}</td>
                        <td>{t("symposium_schedule_date1_sem8_time")}</td>
                        <td>{t("symposium_schedule_date1_sem8_title")}</td>
                        <td>{t("symposium_schedule_date1_sem8_speaker")}</td>
                    </tr>
                    {/* <tr>
                        <td>{t("symposium_schedule_date1_sem8_hours")}</td>
                        <td>{t("symposium_schedule_date1_sem8_time")}</td>
                        <td>{t("symposium_schedule_date1_sem8_title")}</td>
                        <td>{t("symposium_schedule_date1_sem8_speaker")}</td>
                    </tr> */}
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    )
}

export default SymposiumSchedule;